<script>
import Title from "@/components/admin/common/TitleArea.vue"
import { updateReports } from "@/data/updateReports"

export default {
  name: "Admin-update-report",
  meta: {
    title: "어드민-업데이트 리포트"
  },
  components: {
    Title,
  },
  data() {
    return {
      description   : {
        title : '업데이트 리포트'
      },
      updateReport : updateReports
    }
  },
  /*
  setup(){
  },
  */

  methods: {
    
  },
  
  mounted() {
    this.$log.info("[ Page / 업데이트 리포트 ]")
  },
}
</script>


<template>
  
  <q-page class="q-pa-lg">
    <div class="row">
      <div class="col">
        <Title
          :desc="description">
        </Title>
      </div>
    </div>

    <div class="row q-mt-lg">
      <div class="col">
        <div class="comp-box">
          
          <!-- S : 업데이트 리스트 -->
          <div class="row q-mb-sm">
            <div class="col">
              <h4></h4>
              <q-markup-table
                flat
                bordered>
                <thead>
                  <tr>
                    <th>Version</th>
                    <th>업데이트 내용</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in updateReport" :key="item.ver">
                    <td>{{item.ver}}</td>
                    <td>
                      <ul>
                        <li v-for="(report, idx) in item.reports" :key="`${item.ver}-${idx}`">{{ report }}</li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </q-markup-table>
            </div>
          </div>
          <!-- E : 업데이트 리스트 -->

        </div>
      </div>
    </div>
  </q-page>

</template>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.update-head {
  margin-top: 1rem;
  margin-bottom: .15rem;
}
thead {
  th {
    font-size: 1.25rem;
  }
}
tbody {
  td {
    margin-top: .25rem;
    margin-bottom: .25rem;

    &:first-child {
      font-size: 1.5rem;
      text-align: center;
      width: 150px;
    }
  }
}
</style>
